import { sessionScopeOf, type SessionListener, type StoredSession } from './http-client';

export interface SessionScopedCache {
  cancelQueries(): Promise<unknown>;
  resetQueries(): Promise<unknown>;
  clear(): void;
  getMutationCache(): { clear(): void };
}

export interface SessionTransitionSteps {
  stopActivity?: () => void;
  show: (session: StoredSession | null) => void;
  startActivity?: () => void;
}

export const followSessionTransitions = (
  subscribe: (listener: SessionListener) => () => void,
  cache: SessionScopedCache,
  steps: SessionTransitionSteps,
): (() => void) =>
  subscribe((next, previous) => {
    const crossing = sessionScopeOf(next) !== sessionScopeOf(previous);
    if (crossing) {
      steps.stopActivity?.();
      void cache.cancelQueries();
      if (next) {
        cache.getMutationCache().clear();
        void cache.resetQueries();
      } else {
        cache.clear();
      }
    }
    steps.show(next);
    if (crossing && next) steps.startActivity?.();
  });
